module.exports = __webpack_public_path__ + "static-appopensalud/img/opensalud360_mx_healthierlives_white.0ef20b4.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/opensalud360_mx_healthierlives_white.svg
// module id = 1075
// module chunks = 120